import React from 'react';

const Auth = ({
  username = ''
}) => {
  return (
    <div className="auth">
      Xin chào HLV <strong>{username}</strong> - <a href="/user/logout" title="Đăng xuất">Đăng xuất</a>
    </div>
  );
};

export default Auth;
